'use es6';

import http from 'hub-http/clients/apiClient';
import get from 'transmute/get';
import { formatWorkflowFolders, formatWorkflowFoldersResponse } from 'reference-resolvers/formatters/formatWorkflowFolders';
const BASE_URL = 'automationapps/v1/folders';
export const createGetWorkflowFoldersByIds = ({
  httpClient
}) => idsToFetch => {
  return httpClient.get(`${BASE_URL}/batch`, {
    query: {
      folderIds: idsToFetch
    }
  }).then(formatWorkflowFolders);
};
export const getWorkflowFoldersByIds = createGetWorkflowFoldersByIds({
  httpClient: http
});
export const createGetWorkflowFoldersSearchPage = ({
  httpClient
}) => props => {
  const {
    count: limit,
    offset = 0,
    query: name
  } = props.toJS();
  return httpClient.get(BASE_URL, {
    query: {
      limit,
      offset,
      name
    }
  }).then(formatWorkflowFoldersResponse);
};
export const getWorkflowFoldersSearchPage = createGetWorkflowFoldersSearchPage({
  httpClient: http
});
export const createGetAllWorkflowFolders = ({
  httpClient
}) => () => httpClient.get(BASE_URL).then(get('results')).then(formatWorkflowFolders);
export const getAllWorkflowFolders = createGetAllWorkflowFolders({
  httpClient: http
});